import { useEffect, useState } from "react";
import { ITexts } from "../../interfaces/hooks/IUseShareModalTexts";
import { useShareContext } from "../../components/training-plan/material";

export const useShareModalTexts = () => {
  const [texts, setTexts] = useState<ITexts>({
    componentTitle: null,
    messageTitle: null,
    messageDescription: null,
    componentDescription: null,
  });

  const { state } = useShareContext();

  useEffect(() => {
    if (state.type) {
      setTexts({
        messageTitle: `Pod1um ${state.type}`,
        componentTitle: `Share this ${state.type.toLowerCase()}`,
        messageDescription: `Here's a ${state.type} available on Pod1um`,
        componentDescription: `Recommend this ${state.type.toLowerCase()} to your network`,
      });
    }
  }, [state.type]);

  return texts;
};
